/**
 * Bus simples baseado em eventos do window para sinalizar que os contadores
 * da sidebar precisam ser revalidados (após criar/deletar cliente, colaborador, equipe, etc.).
 */
const EVENT = "cm:counts-refresh";

export function refreshSidebarCounts() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(EVENT));
  }
}

export function onSidebarCountsRefresh(handler) {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
